import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class ValueTypeWithCardinalityImpl {
  constructor(valueTypeID, multiple) {
    _defineProperty(this, "valueTypeID", void 0);
    _defineProperty(this, "multiple", void 0);
    this.valueTypeID = valueTypeID;
    this.multiple = multiple;
  }
  exactMatch(other) {
    return this.exactValueTypeMatch(other) && this.exactMultipleMatch(other);
  }
  partialMatch(other) {
    return (this.valueTypeID == null || this.exactValueTypeMatch(other)) && (this.multiple == null || this.exactMultipleMatch(other));
  }
  toString() {
    return `${this.valueTypeID ?? "*"}:${this.multiple ?? "*"}`;
  }
  exactValueTypeMatch(other) {
    return this.valueTypeID != null && other.valueTypeID != null && this.valueTypeID === other.valueTypeID;
  }
  exactMultipleMatch(other) {
    return this.multiple != null && other.multiple != null && this.multiple === other.multiple;
  }
}
//# sourceMappingURL=ValueTypeWithCardinalityImpl.js.map
